import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from "react-oidc-context";
import config from './config/apiConfig';
import { BffAuthProvider, bffSessionEnabled } from './auth/session';

const cognitoAuthConfig = {
  authority: config.cognito.authority,
  client_id: config.cognito.clientId,
  redirect_uri: `${window.location.origin}/ask`,
  response_type: "code",
  scope: "email openid profile",
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {bffSessionEnabled ? (
      // Sign-in runs through the AgentCore front door. See src/auth/session.js.
      <BffAuthProvider>
        <App />
      </BffAuthProvider>
    ) : (
      <AuthProvider {...cognitoAuthConfig}>
        <App />
      </AuthProvider>
    )}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
